import React, { useState } from 'react'
 
 
import HolidaysList from './HolidaysList';
import HolidaysForm from './HolidaysForm';

const Holidays= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <HolidaysForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <HolidaysList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}  
    </>
  )
}

export default Holidays